// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1OdJk","icon":"SortAdornment_icon__2Mtpl","up":"SortAdornment_up__3S8n0","down":"SortAdornment_down__2HQGS","active":"SortAdornment_active__3Qlyk"};